@for (item of orderSummaryLineItems(); track item.id) {
  <order-summary-row [item]="item.item" [extraItem]="item.extraItem" />
}

<hr sbDivider />

<!-- Subtotal -->
@if (showSubscriptionDiscount()) {
  <order-summary-row
    [item]="{
      description: 'Subtotal' | translate,
      amount: estimates().subtotal_before_discount,
    }"
  />

  <order-summary-row
    [isDiscount]="true"
    [item]="{
      description:
        'Subscription discount ([percentage]%)' | translate: { percentage: subscriptionDiscountPercentage() },
      amount: estimates().total_discount * -1,
    }"
  />
  <order-summary-row
    [item]="{
      description: 'Subtotal after discount' | translate,
      amount: estimates().sub_total,
    }"
  />
} @else {
  <order-summary-row
    [item]="{
      description: 'Subtotal' | translate,
      amount: estimates().sub_total,
    }"
  />
}

<!-- VAT -->
<order-summary-row
  [item]="{
    description: 'VAT' | translate,
    amount: estimates().tax_amount,
    note: vatNote(),
  }"
/>
<!-- Total -->
@if (yearlyBilling()) {
  <order-summary-row
    [item]="{
      description: 'Total per year' | translate,
      note:
        (estimates().monthly_to_yearly ? 'Due on [date]' : 'Due on [date], then every year')
        | translate: { date: estimates().next_billing_date | localeDate: 'long' },
      amount: estimates().total,
    }"
  />
} @else {
  <order-summary-row
    [item]="{
      description:
        'Total due on [date]'
        | translate
          : {
              date: estimates().next_billing_date | localeDate: 'long',
            },
      amount: estimates().total,
    }"
  />
}

@if (hasAnyDiscount()) {
  <div class="mt-2 flex items-center gap-1 rounded-lg border border-success-subtle bg-success-subtle p-3">
    <sb-icon class="size-5 shrink-0 text-success" [name]="'check-circle-regular'" />
    <span class="text-sm font-medium text-success-strong">
      {{ 'Discount applied to your subscription' | translate }}
    </span>
  </div>
}
